import styled from 'styled-components';

const DocumentCameraSC = styled.div`
  margin: 0;
  border: 2px dashed #e0e0e0;
  border-radius: 12px;
  padding: 24px;
  background: #fafafa;

  .document-type-header {
    text-align: center;
    margin-bottom: 20px;

    .document-type {
      font-weight: 600;
      color: #333;
    }
  }

  .error-message {
    background: #ffebee;
    border: 1px solid #f44336;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 16px;
    text-align: center;

    .error {
      color: #d32f2f;
    }
  }

  .camera-controls {
    text-align: center;
  }

  .upload-options {
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    align-items: center;
  }

  /* White upload button styling */
  .upload-white {
    background: #ffffff;
    color: #333;
    border: 1px solid #dddddd;
    border-radius: 12px;
  }
  .upload-white:hover {
    background: #ffffff;
    border-color: #cccccc;
  }

  .instruction {
    color: #666;
    font-style: italic;
    max-width: 300px;
    margin: 0 auto;
    line-height: 1.4;
  }

  .camera-view {
    text-align: center;
    border-radius: 8px;
    padding: 16px;
    margin: 16px 0;
    background: #f8f9fa !important;
  }

  .video-container {
    position: relative;
    display: inline-block;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background: #f8f9fa;
    max-width: 500px;
    width: 100%;
    aspect-ratio: 1.6; /* Rovnaký pomer ako občiansky preukaz */
    border: 3px solid transparent;
    transition: border-color 0.3s ease;
  }

  /* Farebné rámčeky pre detekciu */
  .video-container.detection-good {
    border-color: #28a745; /* Zelený rámček pre správne umiestnenie */
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  }

  .video-container.detection-partial {
    border-color: #ffc107; /* Žltý rámček pre čiastočnú detekciu */
    box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
  }

  .video-container.detection-bad {
    border-color: #dc3545; /* Červený rámček pre zlé umiestnenie */
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
  }

  .video-stream {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    display: block;
    background: transparent !important;
    object-fit: cover;
  }

  .id-card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }

  .id-card-frame {
    position: relative;
    width: 70%;
    height: 60%;
    border: none;
    border-radius: 8px;
    background: transparent;
    box-shadow: none;
  }

  .overlay-instruction {
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    padding: 8px 16px;
    border-radius: 4px;
    white-space: nowrap;
  }

  .overlay-text {
    color: #fff !important;
    font-size: 14px;
    margin: 0;
  }

  .detection-warning {
    margin-top: 12px;
    padding: 8px 16px;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 6px;
    text-align: center;

    .warning-text {
      color: #856404;
      font-size: 13px;
      margin: 0;
    }
  }

  .detection-status {
    margin-top: 8px;
    padding: 6px 12px;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    font-weight: 600;

    &.status-good {
      background: #d4edda;
      color: #155724;
      border: 1px solid #c3e6cb;
    }

    &.status-partial {
      background: #fff3cd;
      color: #856404;
      border: 1px solid #ffeaa7;
    }

    &.status-bad {
      background: #f8d7da;
      color: #721c24;
      border: 1px solid #f5c6cb;
    }
  }

  .captured-image {
    text-align: center;
  }

  .document-preview {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 1.6;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 2px solid #e0e0e0;
  }

  .image-controls,
  .camera-controls {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 16px;
  }

  .countdown-timer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 20px 30px;
    border-radius: 50%;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
    z-index: 10;
    min-width: 100px;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: pulse 0.5s ease-in-out;

    .countdown-text {
      color: white !important;
      font-size: 48px;
      font-weight: bold;
      margin: 0;
    }
  }

  @keyframes pulse {
    0% {
      transform: translate(-50%, -50%) scale(0.8);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.2);
    }
    100% {
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .auto-capture-toggle {
    margin-top: 12px;
    text-align: center;

    .toggle-button {
      background: none;
      border: 1px solid #ddd;
      border-radius: 20px;
      padding: 6px 12px;
      cursor: pointer;
      font-size: 12px;
      transition: all 0.3s ease;

      &.active {
        background: #28a745;
        color: white;
        border-color: #28a745;
      }

      &:hover {
        border-color: #28a745;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 16px;

    .upload-options {
      flex-direction: column;
      align-items: center;
    }

    .video-stream,
    .document-preview {
      max-width: 100%;
    }

    .image-controls {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export default DocumentCameraSC;
